import { forEach, map, every, compact } from 'lodash';

import { ArrayProperty, isArray, concat, resolve } from 'gear';

import { Xml } from '../util';

import { Figure } from '../figure/figure';
import { AbsoluteAnchor } from '../figure/anchor';

import { Process } from './process';

export const Processes = ArrayProperty.extend({ typeName: 'Process[]',

  // Add processes at the right spot

  add( p ) {
    if( isArray(p) ) {
      return compact( map( p , pk => {
        this.add(pk); // [TODO]
      }) );
    }

    const requiresText = p.requiresText();
    if( ! requiresText ) {
      return this.callParent(p);
    }

    // Validate text preservation chain
    const owner = this._owner;
    const ownerOutputsText = owner && owner.outputsText();

    if( ! ownerOutputsText ) {
      // We can not add this process
      return null;
    }

    let k = 0;
    for( let kEnd = this.length;
         k < kEnd && this[k].outputsText() ; ++k ) { void 0; }

    return this.insert(k,p);
  },

  canProcess( figure ) {
    return this.length === 0 || every( this, p => p.canProcess(figure) );
  },

  // c : {
  //   items: [ TextLayout, GShape, GRaster ],
  //   anchor: ( point ),
  //   textLayouts: [ TextLayout ]
  // }
  process( c ) {

    // This is work in progress, working for text right now
    forEach( this, p => {
      const nc = p.process(c);
      if( nc ) {
        c = nc;
      }
    });

    const outputAnchor = c.anchor;

    // Condense output figures (TextLayout,GShape,GRaster) to one figure
    const outputFigures = c.figures;
    const figures = [];

    let polyregions = [];

    const buildShape = function() {

      // PowerClipLink remains in output figures, the input powerclip content
      // is what end ups being drawn directly, if the output figure needs to be
      // converted to CDL, these links needs to be transformed into proper
      // PowerClipContent arrays at the figure level
      const shape = new Figure.Shape({ polyregions: polyregions,
                              anchor: AbsoluteAnchor(outputAnchor.clone()),
                              pin: outputAnchor.clone() });

      figures.push(shape);

      // Clear the array
      polyregions.splice(0,polyregions.length);
    };
    for(let k = 0, kEnd = outputFigures.length; k < kEnd; ++k ) {

      const figure = outputFigures[k];
      if( figure.isGShape ) {
        polyregions = concat(polyregions,figure.polyregions);
      }
      else if( figure.isTextLayout ) {
        const gs = figure.toGShape();
        polyregions = concat(polyregions,gs.polyregions);
      }
      else if( figure.isRaster ) {
        if( polyregions.length > 0 ) {
          buildShape();
        }
        figures.push( figure );
      }
    }
    if( polyregions.length > 0 ) {
      buildShape();
    }

    var outputFigure = null;
    if( figures.length > 1 ) {
      // Review, at this point all figures should be primitives
      // Wire the output of simple shapes, if they are not set
      // This shouldn't be needed, but we must change group metrics
      // to be able to avoid it
      forEach( figures, f => {
        if( ! f._outputFigure ) {
          f._outputFigure = f;
        }
      });

      outputFigure = new Figure.Group({ figures: figures, noProcessor: true });
    }
    else {
      outputFigure = figures[0];
    }

    outputFigure._computedPreScale = c.preScale;
    
    return outputFigure;
  },

  clone() {
    return new Processes(this.callParent());
  },

  cloneDeep() {
    return new Processes(this);
  },

  clearKeeping$(what) {
    const me = this;
    const owner = this._owner;
    if( owner instanceof Figure ) {
      return owner.modifyKeeping$( what, () => {
        return me.clear();
      });
    }
    else {
      return resolve( me.clear() );
    }
  },

  addKeeping$( what,process) {
    const me = this;
    const owner = this._owner;
    if( owner instanceof Figure ) {
      return owner.modifyKeeping$( what, () => {
        return me.add( process );
      });
    }
    else {
      return resolve( me.add( process ) );
    }
  },

  removeKeeping$( what,process) {
    const me = this;
    const owner = this._owner;
    if( owner instanceof Figure ) {
      return owner.modifyKeeping$( what, () => {
        return me.remove( process );
      });
    }
    else {
      return resolve( me.remove( process ) );
    }
  },

  getPens( pens = [] ) {
    forEach( this, p => { p.getPens(pens); } );
    return pens;
  },

  getBrushes( brushes = [] ) {
    forEach( this, p => { p.getBrushes(brushes); } );
    return brushes;
  },

  getColors( colors = [] ) {
    forEach( this, p => { p.getColors(colors); } );
    return colors;
  },

  buildXml( node ) {
    if( this.length > 0 ) {
      const pNode = Xml.appendElement(node,'Processes');
      // invokeMap(this,'buildXml',pNode);
      for(let k=0,kEnd=this.length;k<kEnd;++k) {
        this[k].buildXml(pNode);
      }
    }
    return node;
  }
});

Processes.fromXml = function(node,owner) {
  const processesNode = Xml.child(node,'Processes');
  const processes = processesNode ? Xml.getObjectArray(processesNode,Process) : [];
  return new Processes(processes,owner);
};

Processes.load$ = function(docModel) {
  return Figure.load$(docModel).then( figure => figure.processes.clone() );
};

Xml.Parser['Process[]'] = Xml.makeObjectParser(Processes);



/** WEBPACK FOOTER **
 ** ./src/cdl/process/processes.js
 **/